<template>
  <Layout>
    <!-- Start Service Area -->
    <section class="rn-service-area rn-section-gap">
      <div class="container">
        <div class="row row--30">
          <div class="col-lg-12">
            <SectionTitle
              class="mb--50"
              text-align="center"
              subtitle="Where People and Technology Intersect"
              title="Serving the Needs of Our Clients"
              data-aos="fade-up"
              data-aos-delay="60"
            />
          </div>
        </div>
        <div class="row row--15 service-wrapper">
          <div class="col-12">
            <ServiceCard
              :service="{
                  icon: 'crosshair',
                  id: 'growth-inflection-analysis',
                  title: 'Growth Inflection Analysis',
                  description: '<h2>Overview</h2><p>A focused, two-week engagement that gives your software engineering organization clarity on where you are today, where you want to go, and what\'s standing in the way. Designed for teams preparing to scale, improve delivery, or align leadership.</p><h2>What\'s Included</h2><ul><li>Leadership interview (90 minutes)</li><li>Team and workflow assessment</li><li>Pain point and bottleneck mapping</li><li>Technical and organizational risk review</li><li>Future-state alignment</li><li>Prioritized growth roadmap</li><li>60-minute findings presentation</li></ul><h2>What You Walk Away With</h2><ul><li>A clear picture of your engineering org\'s strengths and weaknesses</li><li>A practical, prioritized plan to unlock growth</li><li>Recommendations tailored to your goals, budget, and timeline</li><li>A foundation for efficient hiring and stronger delivery</li><li>The option to engage us for implementation or coaching</li></ul><h2>Perfect For</h2><p>Engineering organizations facing growth, delivery unpredictability, or structural change.</p><h2>Pricing</h2><p>Flat rate: $5,000</p>'
              }"
              :service-style="`service__style--1 bg-color-blackest radius mt--25`"
              :icon-size="62"
              text-align="left"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Service Area -->

  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import ServiceCard from '../../components/elements/service/ServiceCard'

    export default {
        name: 'GrowthInflectionAnalysis',
        components: {Layout, SectionTitle, ServiceCard},
    }
</script>
